import React, { type FC, useEffect } from "react";
import type { ForgotPasswordProps } from "@components/AuthFlow/ForgotPassword/contract";
import { trackLoaded, withPrefix } from "@tracking/tracking";
import {
  screenNames,
  useScreenState,
} from "clientState/AuthFlow/providers/ScreenProvider";
import { useScreenActions } from "clientState/AuthFlow/providers/ScreenProvider/useScreenActions";
import { useTrackElement, useTracking } from "@edreamsodigeo/frontend-core";
import { Box } from "@edreamsodigeo/prisma-design-system";

import CloseHeader from "../Header/CloseHeader";
import GoBackHeader from "../Header/GoBackHeader";
import ForgotPasswordContent from "./ForgotPasswordContent";

const { FORGOT_PASSWORD } = screenNames;

const ForgotPassword: FC<ForgotPasswordProps> = ({
  isInitial = false,
  trackingPrefix,
  closeScreen,
}) => {
  const { state } = useScreenState();
  const gaTrackingPrefix = state.gaTrackingPrefix || trackingPrefix;
  const trackingRef = useTrackElement(
    ["display"],
    withPrefix(FORGOT_PASSWORD, trackingPrefix),
  );
  const { trackEvent } = useTracking();
  const { renderSigninScreen } = useScreenActions();

  const onGoBack = (): void => renderSigninScreen({ ...state.userData });

  useEffect(() => {
    trackLoaded({
      trackEvent,
      screen: FORGOT_PASSWORD,
      prefix: gaTrackingPrefix,
    });
  }, [gaTrackingPrefix, trackEvent]);

  return (
    <Box ref={trackingRef}>
      {isInitial ? (
        <CloseHeader
          closeScreen={(): void => closeScreen && closeScreen(false)}
          screen={FORGOT_PASSWORD}
          trackingPrefix={trackingPrefix}
        />
      ) : (
        <GoBackHeader
          onGoBack={onGoBack}
          screen={FORGOT_PASSWORD}
          trackingPrefix={trackingPrefix}
        />
      )}
      <ForgotPasswordContent trackingPrefix={trackingPrefix} />
    </Box>
  );
};

export default ForgotPassword;
